import { render, staticRenderFns } from "./FlowArea.vue?vue&type=template&id=b061ce4c"
import script from "./FlowArea.vue?vue&type=script&lang=js"
export * from "./FlowArea.vue?vue&type=script&lang=js"
import style0 from "./FlowArea.vue?vue&type=style&index=0&id=b061ce4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports